import { notification } from 'antd';
import { FcCancel, FcOk } from "react-icons/fc";
import { IoWarningOutline } from "react-icons/io5";

import { ONE_HUNDRED_SUCCESS_CODE, TWO_HUNDRED_SUCCESS_CODE } from "../utils/app-common";


export const getNotificationStyle = (response: any) => {

    if ((response?.status === TWO_HUNDRED_SUCCESS_CODE)
        || (response?.statusCode === TWO_HUNDRED_SUCCESS_CODE)
        || (response?.responseCode === ONE_HUNDRED_SUCCESS_CODE)) {
        notification.open({
            message: response?.data?.data?.response || response?.data?.data?.message || response?.data?.message || response?.statusText || response?.response || response?.responseMessage || 'Success',
            style: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            icon: <FcOk />
        });
    } else {
        notification.open({
            message: response?.data?.message || response?.responseMessage || response?.message || 'Something Went Wrong',
            style: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            icon: <FcCancel />
        });
    }
}

export const successNotificationStyle = (message: string, description?: string) => {
    notification.open({
        message,
        description: description ? <span className="notification-description">{description}</span> : undefined,
        style: {
            color: 'rgba(0, 0, 0, 0.65)',
            border: '1px solid #b7eb8f',
            backgroundColor: '#f6ffed'
        },
        icon: <FcOk />
    });
};

export const warningNotificationStyle = (description: string) => {
    notification.open({
        message: 'Warning',
        description: <span className="notification-description">{description}</span>,
        style: {
            color: '#856404',
            border: '1px solid #ffeeba',
            backgroundColor: '#fff3cd',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        },
        icon: <IoWarningOutline style={{ color: '#856404', fontSize: '18px' }} />,
        duration: 4.5,
    });
};